<script lang="ts">
	import { _ } from '@repo/i18n'

	interface Props {
		value: string
	}

	let { value }: Props = $props()

	let lines = $derived(value.trim().split('\n').length)
</script>

<div class="mt-1"></div>
<div class="text-xs">
	{$_('form.lines')}
	{lines}
</div>
